import React from 'react'
import { Link } from 'react-router-dom'

interface Props {
    to: string
    children: JSX.Element
    onClick?: () => void
    dataTestId?: string
    isDisabled?: boolean
}

const RawLink = ({ to, children, onClick, dataTestId, isDisabled }: Props) => {
    const linkStyle = {
        display: 'inline',
        textDecoration: 'none',
        color: 'inherit',
    }
    const handleLinkClick = () => {
        if (onClick) {
            onClick()
        }
    }
    return (
        <>
            {isDisabled && <>{children}</>}
            {!isDisabled && (
                <Link
                    target={to?.includes('http') ? '_blank' : undefined}
                    rel={to?.includes('http') ? 'noreferrer' : undefined}
                    to={to}
                    style={linkStyle}
                    onClick={handleLinkClick}
                    data-testid={dataTestId}>
                    {children}
                </Link>
            )}
        </>
    )
}

export { RawLink }
